import type { ChangelogEntry } from "../types";

/** VIB-2832-oppfølging. Utrullingene var tunge å lese. */
export const UTRULLING_LESBARHET_2026_10: ChangelogEntry = {
  id: "2026-10-07-utrulling-lesbarhet",
  date: "2026-10-07",
  title: "Nytt i Revehiet er lettere å lese",
  summary: "Kortere tekst og tydeligere forklaringer under hvert punkt.",
  sections: [
    {
      heading: "Hjelp",
      items: [
        {
          title: "Kortere og tydeligere utrullinger",
          kind: "forbedret",
          body: "Hvert punkt har én kort forklaring, i større og mørkere tekst med mer luft mellom punktene.",
        },
      ],
    },
  ],
};
